module.exports = __webpack_public_path__ + "static/media/DT-NZ-2024-White.631c3608.png";